
export const GET_NEWS_SUPERVISORS = 'GET_NEWS_SUPERVISORS';
export const EDIT_NEWS_SUPERVISOR = 'EDIT_NEWS_SUPERVISOR';
export const NEW_NEWS_SUPERVISOR = 'NEW_NEWS_SUPERVISOR';
export const DELETE_NEWS_SUPERVISOR = 'DELETE_NEWS_SUPERVISOR';

export function getNewsSupervisors(supervisors, error=null) {
    return {
        type: GET_NEWS_SUPERVISORS,
        supervisors,
        error
    }
}

export function editNewsSupervisor (supervisor, error=null) {
    return {
        type: EDIT_NEWS_SUPERVISOR,
        supervisor,
        error
    }
}

export function addNewsSupervisor (supervisor, error=null) {
    return {
        type: NEW_NEWS_SUPERVISOR,
        supervisor,
        error
    }
}

// Delete Supervisor
export function deleteNewsSupervisor (id, error=null) {
    return {
        type: DELETE_NEWS_SUPERVISOR,
        id,
        error
    }
}